import * as React from "react";
import { useEffect } from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import { connect } from "react-redux";
import SettingsPhoneIcon from "@mui/icons-material/SettingsPhone";
import TuneIcon from "@mui/icons-material/Tune";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import SettingsIcon from "@mui/icons-material/Settings";
import { NavLinks } from "../funtComponents/functElements";

import { useDispatch } from "react-redux";

import { USER_MENU_STATE_CHANGE } from "../../redux/constanst/index";
import Button from "@mui/material/Button";
import { mapStateToProps } from "./models/buscar";

import Sidebar from "../Sidebar";

function NestedList(props) {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(true);
  const [selectOpt, setSelectOpt] = React.useState("Dash");

  const [menu2, setMenu2] = React.useState();
  const [menuOpt] = React.useState([
    {
      title: "Tablero",
      icon: <LeaderboardIcon />,
    },
    {
      title: "Configuracion",
      icon: <TuneIcon />,
    },
    {
      title: "Detalle de Anexos",
      icon: <PermPhoneMsgIcon />,
    },
    {
      title: "Facturacion",
      icon: <CreditScoreIcon />,
    },
    {
      title: "Mis llamadas",
      icon: <SettingsPhoneIcon />,
      Category: [
        {
          id: 0,
          name: "Entrantes",
        },
        {
          id: 1,
          name: "Salientes",
        },
        {
          id: 2,
          name: "Combinado",
        },
        /* {
          id: 3,
          name: 'Distribucion',
        } */
      ],
    },
  ]);

  const hiter = (item) => {
    if (item === "Tablero")
      return { title: "Tablero", icon: <LeaderboardIcon /> };
    if (item === "Configuracion")
      return { title: "Configuracion", icon: <TuneIcon /> };
    if (item === "Facturacion")
      return { title: "Facturacion", icon: <CreditScoreIcon /> };
    if (item === "Detalle de Anexos")
      return { title: "Detalle de Anexos", icon: <PermPhoneMsgIcon /> };
    if (item === "Mis llamadas")
      return {
        title: "Mis llamadas",
        icon: <SettingsPhoneIcon />,
        Category: [
          {
            id: 0,
            name: "Entrantes",
          },
          {
            id: 1,
            name: "Salientes",
          },
          {
            id: 2,
            name: "Combinado",
          },
          /* {
          id: 3,
          name: 'Distribucion',
        } */
        ],
      };
  };

  const handleIncludes = (title) => {
    title = title.toString();

    if (!check().includes(title)) {
      setMenu2([...menu2, hiter(title)]);
    } else {
      const indice = check().indexOf(title);

      changeArr().splice(indice, 1);
      setMenu2([...changeArr()]);
    }
  };

  const handleClick = () => {
    setOpen(open);
  };

  const color = () => {
    return { color: "lightgray" };
  };

  const check = () => {
    return menu2.map((opt) => opt.title);
  };

  const changeArr = () => {
    if (menu2 === undefined) return menuOpt;
    return menu2;
  };

  const saveChanges = () => {
    dispatch({ type: USER_MENU_STATE_CHANGE, menu: menu2 });
    setSelectOpt("Dash");
  };

  useEffect(() => {
    setMenu2(props.menu);
  }, [props.menu]);

  return (
    <>
      {selectOpt === "Dash" && props.token.level !== "admin" ? (
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "#454545" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader
              style={{
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#454545",
                color: "rgba(238, 238, 238, 0.4)",
                fontSize: 13,
                fontWeight: 600,
              }}
              component="div"
              id="nested-list-subheader"
            >
              Opciones de usuario
              <Button
                variant="text"
                style={{ color: "red" }}
                onClick={() => setSelectOpt("Edit")}
                endIcon={<SettingsIcon style={{ width: 20 }} />}
              ></Button>
            </ListSubheader>
          }
        >
          {props.token.level !== "admin"
            ? changeArr().map((opt) =>
                !opt.title.includes("Mis llamadas") ? (
                  <NavLinks to={opt.title} key={opt.id}>
                    <ListItemButton key={opt.title} inicioBtn>
                      <ListItemIcon
                        style={{ color: "rgba(238, 238, 238, 0.2)" }}
                      >
                        {opt.icon}
                      </ListItemIcon>
                      <ListItemText
                        key={opt.title}
                        primary={opt.title}
                        style={color()}
                      />
                    </ListItemButton>
                  </NavLinks>
                ) : (
                  <>
                    <ListItemButton onClick={handleClick}>
                      <ListItemIcon
                        style={{ color: "rgba(238, 238, 238, 0.2)" }}
                      >
                        <SettingsPhoneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Mis llamadas" style={color()} />
                      {/* {open ? <ExpandLess style={color()} /> : <ExpandMore style={color()} />} */}
                    </ListItemButton>

                    <Collapse
                      in={open}
                      timeout="auto"
                      unmountOnExit
                      style={color()}
                    >
                      <List component="div" disablePadding style={color()}>
                        {opt.Category.map((categ) => (
                          <NavLinks to={categ.name}>
                            <ListItemButton sx={{ pl: 4 }}>
                              <ListItemIcon
                                style={{ color: "rgba(238, 238, 238, 0.2)" }}
                              >
                                <RadioButtonUncheckedIcon
                                  style={{ width: 15 }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={categ.name}
                                disabled={categ.name === "Distribucion"}
                              />
                            </ListItemButton>
                          </NavLinks>
                        ))}
                      </List>
                    </Collapse>
                  </>
                )
              )
            : null}
        </List>
      ) : (
        //Se muestra si es admin MENU
        <List>
          <NavLinks to="/AdminEdit" key="/AdminEdit">
            <ListItemButton key="/AdminEdit" inicioBtn>
              <ListItemIcon style={{ color: "rgba(238, 238, 238, 1)" }}>
                Editar Empresas
              </ListItemIcon>
              <ListItemText key="/AdminEdit" style={color()} />
            </ListItemButton>
          </NavLinks>
          <NavLinks to="/AdminEditAnexo" key="/AdminEditAnexo">
            <ListItemButton key="/AdminEditAnexo" inicioBtn>
              <ListItemIcon style={{ color: "rgba(238, 238, 238, 1)" }}>
                Editar Anexos
              </ListItemIcon>
              <ListItemText key="/AdminEditAnexo" style={color()} />
            </ListItemButton>
          </NavLinks>
          <NavLinks to="/AdminEditarTarifa" key="/AdminEditarTarifa">
            <ListItemButton key="/AdminEditarTarifa" inicioBtn>
              <ListItemIcon style={{ color: "rgba(238, 238, 238, 1)" }}>
                Editar Tarifas
              </ListItemIcon>
              <ListItemText key="/AdminEditarTarifa" style={color()} />
            </ListItemButton>
          </NavLinks>
          <NavLinks to="/AdminGeneradorReporte" key="/AdminGeneradorReporte">
            <ListItemButton key="/AdminGeneradorReporte" inicioBtn>
              <ListItemIcon style={{ color: "rgba(238, 238, 238, 1)" }}>
                Generador de Reporte
              </ListItemIcon>
              <ListItemText key="/AdminGeneradorReporte" style={color()} />
            </ListItemButton>
          </NavLinks>
        </List>
      )}

      {/*COMIENZO DEL EDIT*/}

      {selectOpt === "Edit" ? (
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "#454545" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader
              style={{
                backgroundColor: "#454545",
                color: "rgba(238, 238, 238, 0.4)",
                fontSize: 13,
                fontWeight: 600,
              }}
              component="div"
              id="nested-list-subheader"
            >
              Selecciona opciones del manú
            </ListSubheader>
          }
        >
          {menuItems.map((opt) => (
            <NavLinks key={opt.id}>
              <ListItemButton
                iniciobBn
                onClick={() => handleIncludes(opt.title)}
              >
                <ListItemIcon style={{ color: "rgba(238, 238, 238, 0.2)" }}>
                  {check().includes(opt.title) ? (
                    <CheckBoxIcon style={{ width: 20, color: "red" }} />
                  ) : (
                    <CheckBoxOutlineBlankIcon
                      style={{ width: 20, color: "grey" }}
                    />
                  )}
                </ListItemIcon>
                <ListItemText primary={opt.title} style={color()} />
              </ListItemButton>
            </NavLinks>
          ))}

          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: 30,
              display: "flex",
            }}
          >
            <Button
              variant="text"
              style={{
                color: "red",
                fontSize: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={saveChanges}
            >
              guardar opciones
            </Button>
          </div>
        </List>
      ) : null}

      <Sidebar />
    </>
  );
}

const menuItems = [
  {
    title: "Tablero",
  },
  {
    title: "Configuracion",
  },
  {
    title: "Mis llamadas",
  },
  {
    title: "Facturacion",
  },
  {
    title: "Detalle de Anexos",
  },
];

export default connect(mapStateToProps, null)(NestedList);
